import React from 'react';

import { useIntl } from 'react-intl-next';

import { N500 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

// TODO: Replace this custom svg with `import CommentIcon from '@atlaskit/icon/core/comment';` once the icon is the same as this one
const CommentIcon = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<svg
			aria-label={formatMessage(messages.commentIconLabel)}
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			color={token('color.icon', N500)}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.77126 13.0019C3.43856 13.2168 3 12.9779 3 12.5819V5C3 3.89543 3.89543 3 5 3H11C12.1046 3 13 3.89543 13 5V8.91667C13 10.0212 12.1046 10.9167 11 10.9167H7L3.77126 13.0019ZM6.55773 9.41667H11C11.2761 9.41667 11.5 9.19281 11.5 8.91667V5C11.5 4.72386 11.2761 4.5 11 4.5H5C4.72386 4.5 4.5 4.72386 4.5 5V10.7456L6.55773 9.41667Z"
				fill={token('color.icon', N500)}
			/>
		</svg>
	);
};

export default CommentIcon;
